import React, { useEffect } from "react";
import HomeReviews from "../components/homepage-components/HomeReviews";
import Faq from "../components/universal-components/Faq";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import ContentLeft from "../components/ContentLeft";
import ContentRight from "../components/ContentRight";
import CallToAction from "../components/CallToAction";
import { repairContent } from "../page-content/repairContent";

const BoilerRepairs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={repairContent} />
      <Intro data={repairContent} />
      <ContentLeft data={repairContent} />
      <ContentRight data={repairContent} />
      <CallToAction data={repairContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default BoilerRepairs;
